import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-carousel-cart-viewer', (editor, opts) => {
  const config = {
    blocks: [
      'carouselCartViewer',
    ],
    name: 'carouselCartViewer',
    stylePrefix: 'gjs-',
    defText: 'Sample',
    category: 'Pagos',
    labelComponent: 'Carousel Visualizar Carrito',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
